import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DesignOrigin, Job } from '@paragon/contract-library';

interface JobState extends Job {
  readonly jobId: number;
  readonly designOrigin: DesignOrigin;
}

// The job is immediately loaded on page load, so it's more convenient to assume it's loaded instead of littering
// non-null assertions everywhere.
const initialState: JobState = {} as JobState;

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    jobLoaded: (state, action: PayloadAction<Job>) => ({ ...action.payload, jobId: action.payload.id }) as JobState,
    jobSetDesignOrigin: (state, action: PayloadAction<{ readonly designOrigin: DesignOrigin }>) => {
      const { designOrigin } = action.payload;
      state.designOrigin = designOrigin;
    },
    jobLocked: (state) => {
      state.isLocked = true;
    },
    jobUnlocked: (state) => {
      state.isLocked = false;
    },
  },
});

export const { jobLoaded, jobSetDesignOrigin, jobLocked, jobUnlocked } = jobSlice.actions;
export const job = jobSlice.reducer;
